import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ role, children }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-500">
        <div className="animate-pulse font-display">Loading…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (role && user.role !== role && !(role === "clinician" && user.is_coach)) {
    return <Navigate to={user.role === "clinician" ? "/clinician" : "/client"} replace />;
  }
  if (user.mfa?.blocked && !pathname.startsWith("/security") && !pathname.startsWith("/billing") && !pathname.startsWith("/payment")) {
    return <Navigate to="/security?required=1" replace />;
  }
  return children;
}
